/* Legacy code - ignore complexity errors */
/* eslint complexity: 0 */
import React from 'react';
import Flexbox from 'flexbox-react';
import { inject, observer } from 'mobx-react';
import { Button, Classes, Collapse, Intent } from '@blueprintjs/core';
import _ from 'lodash';
import classNames from 'classnames';

@inject('CurrentUserStore', 'WorkspaceStore', 'ToastStore')
@observer
export default class WorkspaceEditDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isOpen: false,
      isBlurred: [],
    };
  }

  toggleOpen() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  toggleLoading = () => {
    this.setState({
      isSubmitting: !this.state.isSubmitting,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.toggleLoading();
    this.setState({ isBlurred: [] });
    const newObj = {
      name: this.props.WorkspaceStore.newWorkspace.name,
      description: this.props.WorkspaceStore.newWorkspace.description,
    };
    this.props.WorkspaceStore.changeWorkspace(newObj)
      .then(() => {
        this.toggleLoading();
        this.toggleOpen();
      })
      .catch(() => {
        this.toggleLoading();
      });
  }

  handleInputChange(e) {
    this.props.WorkspaceStore.updateNewWorkspace(
      e.target.value,
      e.target.name
    );
  }

  handleCancel() {
    this.props.WorkspaceStore.resetWorkspaceAttribute('name');
    this.props.WorkspaceStore.resetWorkspaceAttribute('description');
    this.toggleOpen();
  }

  handleBlurChange(e) {
    if (!_.includes(this.state.isBlurred, e.target.name)) {
      const newBlurState = this.state.isBlurred;
      newBlurState.push(e.target.name);
      this.setState({ isBlurred: newBlurState });
    }
  }

  renderErrors(field) {
    if (
      _.includes(this.state.isBlurred, field) &&
      !this.props.WorkspaceStore.newWorkspace[`${field}Valid`]
    ) {
      return (
        <div className="bp3-form-helper-text">
          {this.props.WorkspaceStore.newWorkspace[`${field}Error`]}
        </div>
      );
    }
    return undefined;
  }

  render() {
    return (
      <Flexbox
        flexDirection="column"
        flexGrow={1}
        marginBottom="20px"
      >
        <Flexbox
          flexDirection="row"
          justifyContent="space-between"
          flexGrow={1}
        >
          <Flexbox flexDirection="column">
            {/* okay to disable as alternative functionality provided */}
            {/* eslint-disable-next-line */}
            <h4
              className={`${Classes.HEADING} bp3-cursor-pointer noselect`}
              onClick={() => this.toggleOpen()}
            >
              {I18n.t('js.details')}
            </h4>
            <p className="noselect">
              {I18n.t('js.change_workspace_name_and_description')}
            </p>
          </Flexbox>
          <Flexbox flexDirection="column">
            <Button
              text={
                this.state.isOpen
                  ? I18n.t('js.close')
                  : I18n.t('js.expand')
              }
              icon={this.state.isOpen ? 'chevron-up' : 'expand-all'}
              onClick={() => this.toggleOpen()}
            />
          </Flexbox>
        </Flexbox>
        <Collapse isOpen={this.state.isOpen}>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <Flexbox flexDirection="column">
              <Flexbox
                flexGrow={1}
                className={
                  _.includes(this.state.isBlurred, 'name') &&
                  !this.props.WorkspaceStore.newWorkspace.nameValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="name">
                  {I18n.t('js.workspace_name')}
                  <span className="bp3-text-muted push-5-l">
                    ({I18n.t('js.required')})
                  </span>
                </label>
                <div className="bp3-form-content">
                  <div
                    className={
                      _.includes(this.state.isBlurred, 'name') &&
                      !this.props.WorkspaceStore.newWorkspace
                        .nameValid
                        ? classNames(
                            'bp3-input-group bp3-intent-danger'
                          )
                        : classNames('bp3-input-group')
                    }
                  >
                    <input
                      autoComplete="off"
                      className="bp3-input bp3-fill"
                      type="text"
                      placeholder={I18n.t(
                        'js.enter_a_name_for_your_workspace'
                      )}
                      name="name"
                      value={
                        this.props.WorkspaceStore.newWorkspace.name
                      }
                      onChange={this.handleInputChange.bind(this)}
                      onBlur={this.handleBlurChange.bind(this)}
                      dir="auto"
                    />
                  </div>
                  {this.renderErrors('name')}
                </div>
              </Flexbox>
              <Flexbox
                flexGrow={1}
                className={
                  _.includes(this.state.isBlurred, 'description') &&
                  !this.props.WorkspaceStore.newWorkspace
                    .descriptionValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="description">
                  {I18n.t('js.workspace_description')}
                  <span className="bp3-text-muted push-5-l">
                    ({I18n.t('js.required')})
                  </span>
                </label>
                <div className="bp3-form-content">
                  <div
                    className={
                      _.includes(
                        this.state.isBlurred,
                        'description'
                      ) &&
                      !this.props.WorkspaceStore.newWorkspace
                        .descriptionValid
                        ? classNames(
                            'bp3-input-group bp3-intent-danger'
                          )
                        : classNames('bp3-input-group')
                    }
                  >
                    <textarea
                      className="bp3-input bp3-fill"
                      type="text"
                      placeholder={I18n.t(
                        'js.enter_a_description_for_your_workspace'
                      )}
                      name="description"
                      value={
                        this.props.WorkspaceStore.newWorkspace
                          .description
                      }
                      onChange={this.handleInputChange.bind(this)}
                      onBlur={this.handleBlurChange.bind(this)}
                      dir="auto"
                    />
                  </div>
                  {this.renderErrors('description')}
                </div>
              </Flexbox>
            </Flexbox>
            <Flexbox>
              <div>
                <Button
                  intent={Intent.PRIMARY}
                  type="submit"
                  disabled={
                    !this.props.WorkspaceStore.newWorkspace.nameValid
                  }
                  text={I18n.t('js.save_changes')}
                  loading={this.state.isSubmitting}
                  icon="tick"
                />
                <Button
                  className="push-10-l"
                  icon="cross"
                  text={I18n.t('js.cancel_changes')}
                  onClick={this.handleCancel.bind(this)}
                />
              </div>
            </Flexbox>
          </form>
        </Collapse>
      </Flexbox>
    );
  }
}
